import {isFeatureEnabled} from 'feature-flags';

import {featureFlags} from '@dms/feature-flags';

import {usePermissions} from './usePermissions/usePermissions';

/**
 * Whether the viewer may open a stored call's detail page: the telephony flag plus `CALL / READ`,
 * the same gate as the telephony module. Every "Detail" / "Open call" entry point uses it.
 */
export function useCanOpenTelephonyCall() {
  const [canReadCall] = usePermissions({permissionKeys: ['callRead']});

  return isFeatureEnabled(featureFlags.CORE_TELEPHONY) && canReadCall;
}
